module.exports = require("@material-ui/icons/FiberManualRecord");


//////////////////
// WEBPACK FOOTER
// external "@material-ui/icons/FiberManualRecord"
// module id = 584
// module chunks = 0